// src/hooks/nodeCreationHandlers.ts
import { useReactFlow } from '@xyflow/react';
import { useCallback } from 'react';
import { useCreateAnnotationNode } from '@/hooks/useCreateAnnotationNode';
import { useCreateRandomSequenceAutomationPoCNode } from '@/hooks/useCreateRandomSequenceAutomationPoCNode';
import { useNodeCreation } from '@/hooks/useNodeCreation';

export const useNodeCreationHandlers = (user: { email: string }) => {
  const { screenToFlowPosition } = useReactFlow();
  const { addNode } = useNodeCreation(() => {}, user.email); // Dummy function for addNode
  const createAnnotationNode = useCreateAnnotationNode();
  const createRandomSequenceNode = useCreateRandomSequenceAutomationPoCNode();

  const onCreatingAnnotationNode = useCallback(() => {
    createAnnotationNode({
      userEmail: user.email,
      content: '',
      arrowStyle: {},
      titleColor: '#bbbbbb',
      contentColor: '#555555',
      bracketColor: '#000000',
    });
  }, [createAnnotationNode, user]);

  const onCreatingRandomSequenceNode = useCallback(() => {
    createRandomSequenceNode({
      userEmail: user.email,
      content: '',
      arrowStyle: {},
      titleColor: '#bbbbbb',
      contentColor: '#555555',
      bracketColor: '#000000',
    });
  }, [createRandomSequenceNode, user]);

  const newNode = useCallback(() => {
    const position = screenToFlowPosition({
      x: window.innerWidth / 2,
      y: window.innerHeight / 2,
    });

    const newNodeData = {
      id: `node-${Date.now()}`,
      type: 'default',
      position,
      width: 400,
      height: 500,
      data: {
        label: `New Node ${new Date()
          .toLocaleString('en-GB', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })
          .replace(/\//g, '')
          .replace(',', '-')
          .replace(/:/g, '')
          .replace(' ', '')}`,
      },
      draggable: true,
      selectable: true,
      connectable: true,
    };

    addNode(newNodeData);
  }, [screenToFlowPosition, addNode]);

  return {
    onCreatingAnnotationNode,
    onCreatingRandomSequenceNode,
    newNode,
  };
};